var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1762_50961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9582 7.13669C15.8528 6.81271 15.5655 6.58334 15.2268 6.5527L10.6081 6.13338L8.78275 1.85987C8.64798 1.5459 8.34134 1.34326 8.00002 1.34326C7.65871 1.34326 7.35194 1.5459 7.21803 1.85987L5.39268 6.13338L0.773216 6.5527C0.434587 6.58395 0.147839 6.81332 0.0418805 7.13669C-0.0634679 7.46067 0.0338237 7.81603 0.289932 8.04064L3.78132 11.1021L2.75189 15.6361C2.67657 15.9695 2.80596 16.3142 3.08258 16.5142C3.23126 16.6222 3.40595 16.6762 3.58125 16.6762C3.73188 16.6762 3.88264 16.6361 4.01729 16.5556L8.00002 14.1742L11.982 16.5556C12.2741 16.7301 12.6415 16.7141 12.9175 16.5142C13.1941 16.3142 13.3235 15.9695 13.2482 15.6361L12.2187 11.1021L15.7101 8.04064C15.9661 7.81603 16.0635 7.46141 15.9582 7.13669Z",
    fill: "#E74C3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1762_50961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c26b8e3947f0dcc91fc6e68e14921d9a.svg";
export { ForwardRef as ReactComponent };